import {Avatar} from 'platform/components';
import {Box, Heading, HStack, VStack, Show, Clickable, Hide} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {GetConversationEventsResponse} from '@chat/shared/validations';
import {RichContentDisplay} from '@chat/ui';

import {EventDate, EventDateProps} from './EventDate';
import {Text as RichContentText} from './richContent/Text';
import {WhatsappTextLink} from './WhatsappTextLink';

interface AgentMessageProps extends Pick<EventDateProps, 'messageStatus' | 'showReadStatus'> {
  event: GetConversationEventsResponse[number];
  onMediaClick?: () => void;
}

export function AgentMessage(props: AgentMessageProps) {
  return (
    <HStack width="100%" justify="flex-end" spacing={1}>
      <VStack spacing={1} width="fit-content" align="flex-start">
        <HStack width="100%">
          <Box
            backgroundColor="palettes.neutral.800.100"
            padding={3}
            borderTopLeftRadius="medium"
            borderBottomLeftRadius="medium"
            borderBottomRightRadius="medium"
            width="100%"
          >
            <VStack spacing={1} width="100%">
              <Heading size={5} align="right" color="white">
                {props.event.sender.displayName}
              </Heading>
              <div>
                <Show when={isNotNilOrEmpty(props.event.mediaId)}>
                  <Clickable onClick={props.onMediaClick}>
                    <WhatsappTextLink isClickable={Boolean(props.onMediaClick)}>
                      {i18n.t('entity.activityPanel.chat.mediaInChat')}
                    </WhatsappTextLink>
                  </Clickable>
                </Show>
                <Hide when={isNotNilOrEmpty(props.event.mediaId)}>
                  <RichContentDisplay
                    markdown={props.event.content}
                    ContentEditableComponent={<RichContentText type="agent" />}
                  />
                </Hide>
              </div>
            </VStack>
          </Box>
          <svg
            width="6"
            height="16"
            viewBox="0 0 6 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.52786 6.67851e-08L0 0L-6.99382e-07 16L5.10557 5.78885C6.43538 3.12925 4.50139 1.96762e-07 1.52786 6.67851e-08Z"
              fill="#172B4D"
            />
          </svg>
        </HStack>
        <EventDate
          timestamp={props.event.createdAt}
          showReadStatus={props.showReadStatus ?? false}
          eventType={props.event.type as 'PLAIN' | 'WHATSAPP'}
          messageStatus={props.messageStatus}
        />
      </VStack>
      <Avatar name={props.event.sender.displayName} size="xSmall" />
    </HStack>
  );
}
